import React from 'react'
import { observer,inject } from 'mobx-react'

import classNames from 'classnames'
import { withStyles } from 'material-ui/styles'
import PropTypes from 'prop-types'
import Button from 'material-ui/Button'
import Dialog from 'material-ui/Dialog'
import Divider from 'material-ui/Divider'
import IconButton from 'material-ui/IconButton'
import Typography from 'material-ui/Typography'
import ReactFitText from 'react-fittext'
import T from 'i18n-react'


@inject('store','ui') @observer
class WelcomePage extends React.Component {
  render () {
    const { classes } = this.props, ui = this.props.ui.catalog, wpSettings = this.props.store.wpSettings
    return (
     <Dialog
      fullScreen
      open={ui.openWelcomePage}
      onClose={ui.handleCloseWelcomePage}
     >
      <div className={classes.flexContainer}>
       <div className={classNames(classes.container,classes.background)} style={{backgroundImage:'url('+wpSettings.backgroundimage+')'}}>

        <div className={classes.textContainer}>
         {wpSettings.logo &&
          <img src={wpSettings.logo} alt="" className={classes.logo}/>
         }

         {wpSettings.title &&
           <ReactFitText compressor={1} maxFontSize={150} minFontSize={50}>
            <h1 className={classNames(classes.title,classes.textColor)}>{wpSettings.title}</h1>
           </ReactFitText>
         }
         {wpSettings.subtitle &&
           <Typography type="title" className={classNames(classes.subtitle,classes.textColor)}>
            {wpSettings.subtitle}
           </Typography>
         }

         <Button raised color="secondary" onClick={ui.handleCloseWelcomePage}> {T.translate("meta.toCatalog")} </Button>

         {wpSettings.description &&
          <Typography type="subheading" className={classNames(classes.description,classes.textColor)}>
           {wpSettings.description}
          </Typography>
         }
        </div>


       </div>
      </div>
     </Dialog>
    )
  }
}


const styles = theme => ({
 flexContainer:{
  flex: '1 0 100%'
 },
 container:{
  flex: '0 0 auto',
  color: 'rgba(255, 255, 255, 1)',
  display: 'flex',
  minHeight: '100vh',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: '#2196f3',
  paddingTop: 96,
  paddingBottom: 80,
  textAlign:'center'
 },
 logo:{
  maxWidth:'35vh',
  position:'absolute',
  left:30,
  top:30
 },
 textContainer:{
  display: 'flex',
  alignItems: 'center',
  paddingLeft: 32,
  paddingRight: 32,
  flexDirection: 'column',
  justifyContent: 'center',
  background:'rgba(0,0,0,.4)',
  paddingTop:15,
  paddingBottom:15
 },
 title:{
  margin:0,
  padding:0
 },
 subtitle:{
   marginBottom:10
 },
 description:{
   marginTop:30,
   marginLeft:'10%',
   marginRight:'10%'
 },
 textColor:{
  color:'#fff'
 },
 background:{
  backgroundRepeat:'no-repeat',
  backgroundSize:'cover',
  backgroundPosition:'center'
 }
})


WelcomePage.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
}

export default withStyles(styles, { withTheme: true })(WelcomePage)



// WEBPACK FOOTER //
// ./src/components/welcomepage.js